import { Chip } from '@/components/ui'
import type { RiskLevel } from '../api/types'

const LABEL: Record<RiskLevel, string> = {
  CRITICAL: 'CRITICAL',
  ACTION_REQUIRED: 'ACTION',
  AT_RISK: 'AT RISK',
  WATCH: 'WATCH',
  OK: 'OK',
}

const VARIANT: Record<RiskLevel, 'danger' | 'warning' | 'info' | 'success'> = {
  CRITICAL: 'danger',
  ACTION_REQUIRED: 'warning',
  AT_RISK: 'warning',
  WATCH: 'info',
  OK: 'success',
}

export function RiskCell({ level }: { level: RiskLevel }) {
  return (
    <Chip size="xs" variant={VARIANT[level]} dot>
      {LABEL[level]}
    </Chip>
  )
}
